module.exports = __webpack_public_path__ + "static/media/whether-widgetbg.612b0185.jpg";